module.exports = __webpack_public_path__ + "static/media/visa.ea1795c8.svg";